// Local translations
export const T = {
  en_GB: {
    sectionVisibility: "Section Visibility",
    sectionVisibilityDesc:
      "Choose which sections to show. You can add multiple components to split sections across pages.",
    income: "Income",
    assets: "Assets",
    liabilities: "Liabilities",
    commitments: "Commitments",
    capacity: "Capacity",
    displayOptions: "Display Options",
    incomeStabilityQuestion: "Income Stability Question",
    incomeStabilityDesc: "Ask about income stability (permanent/temporary/variable)",
    expectingChangesQuestion: "Expected Changes Question",
    expectingChangesDesc:
      "Ask whether the client expects changes to their financial situation. Turn off on all but one component when sections are split across pages.",
    capacityForLoss: "Capacity for Loss Classification",
    capacityForLossDesc: "Auto-calculate and display capacity for loss assessment",
    summaryMetrics: "Summary Metrics",
    summaryMetricsDesc: "Show calculated metrics (net worth, debt ratio, etc.)",
  },
  nb_NO: {
    sectionVisibility: "Seksjonssynlighet",
    sectionVisibilityDesc:
      "Velg hvilke seksjoner som skal vises. Du kan legge til flere komponenter for å dele seksjoner på tvers av sider.",
    income: "Inntekt",
    assets: "Eiendeler",
    liabilities: "Gjeld",
    commitments: "Forpliktelser",
    capacity: "Kapasitet",
    displayOptions: "Visningsalternativer",
    incomeStabilityQuestion: "Spørsmål om inntektsstabilitet",
    incomeStabilityDesc: "Spør om inntektsstabilitet (fast/midlertidig/variabel)",
    expectingChangesQuestion: "Spørsmål om forventede endringer",
    expectingChangesDesc:
      "Spør om kunden forventer endringer i sin økonomiske situasjon. Slå av på alle unntatt én komponent når seksjonene er fordelt på flere sider.",
    capacityForLoss: "Klassifisering av tapsevne",
    capacityForLossDesc: "Beregn og vis vurdering av tapsevne automatisk",
    summaryMetrics: "Sammendragsmål",
    summaryMetricsDesc: "Vis beregnede måltall (nettoverdi, gjeldsgrad, etc.)",
  },
} as const;
